<template>
  <div style="background-color: #7f0000;">
    <div class="header" data-v-72c388a2><img src="@/assets/images/header.jpg" width="100%"></div>
    <nav class="navbar" style="background-color: #000;">
      <div class="container">
        <div class="row navbar-header row" style="float: none;" id="top">
          <!-- モバイル表示用の省略メニュー -->
          <button
            style="float: left !important;"
            type="button"
            class="navbar-toggle"
            data-toggle="modal"
            data-target="#myModalMMenu"
          >
            <span class="sr-only"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a
            class="navbar-brand-top"
            href="javascript:void(0);"
            >Tokyo Indexes</a
          >
          <div class="col-sm-2_5 hidden-xs navbar-brand-subtop">
            -Tokyo Official Site-
          </div>

          <ul class="nav navbar-nav navbar-right hidden-xs">
            <li class="language-link active"><a href="#">English</a></li>
            <li class="language-link ">
              <a href="javascript:void(0);" style="color:#fff;">簡体中文</a>
            </li>
            <li class="language-link "><a href="javascript:void(0);" style="color:#fff;">日本語</a></li>
            <li class="members-link">
              <a href="javascript:void(0);"
                >For Subscribers</a
              >
            </li>
          </ul>
          <!-- Modal -->
          <div
            class="modal fade"
            id="myModalMMenu"
            tabindex="0"
            role="dialog"
            aria-labelledby="myModalLabel"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content" id="myModalLabel">
                <div class="modal-footer">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <ul class="nav navbar-nav navbar-right">
                    <li class="language-link active">
                      <a href="#">English</a>
                    </li>
                    <li class="language-link ">
                      <a href="javascript:void(0);">簡体中文</a>
                    </li>
                    <li class="language-link "><a href="javascript:void(0);">日本語</a></li>
                  </ul>
                </div>

                <ul class="list-group">
                  <li class="list-group-item">
                    <a href="javascript:void(0);">TOP</a
                    ><span class="icon-angle-right pull-right"></span>
                  </li>
                  <li class="list-group-item">
                    <a href="javascript:void(0);"
                      >Index List</a
                    ><span class="icon-angle-right pull-right"></span>
                  </li>
                  <li class="list-group-item">
                    <a
                      href="javascript:void(0);"
                      >Archives</a
                    ><span class="icon-angle-right pull-right"></span>
                  </li>
                  <li class="list-group-item">
                    <a href="javascript:void(0);"
                      >News&amp;Release</a
                    ><span class="icon-angle-right pull-right"></span>
                  </li>
                  <li class="list-group-item">
                    <a href="javascript:void(0);"
                      >License</a
                    ><span class="icon-angle-right pull-right"></span>
                  </li>
                  <li class="list-group-item">
                    <a href="javascript:void(0);"
                      >Governance</a
                    ><span class="icon-angle-right pull-right"></span>
                  </li>

                  <li class="list-group-item">
                    <a href="javascript:void(0);" target="_blank">Asia Indexes</a
                    ><span class="icon-angle-right pull-right"></span>
                  </li>
                  <li class="list-group-item">&nbsp;</li>
                  <li class="list-group-item">
                    <a href="javascript:void(0);"
                      >For Subscribers</a
                    ><span class="icon-angle-right pull-right"></span>
                  </li>
                  <li class="list-group-item">&nbsp;</li>
                  <li class="list-group-item">
                    <a
                      href="javascript:void(0);"
                      onclick="_gaq.push(['_trackEvent', 'TOP_EN', '.PDF', 'terms_of_use_en.pdf'])"
                      target="_blank"
                      >Term of Use(PDF)</a
                    ><span class="icon-angle-right pull-right"></span>
                  </li>
                  <li class="list-group-item">
                    <a href="javascript:void(0);"
                      >Sitemap</a
                    ><span class="icon-angle-right pull-right"></span>
                  </li>
                  <li class="list-group-item">
                    <a
                      href="javascript:void(0);"
                      >Contact</a
                    ><span class="icon-angle-right pull-right"></span>
                  </li>
                  <li class="list-group-item">
                    <a
                      href="javascript:void(0);"
                      onclick="_gaq.push(['_trackEvent', 'TOP_EN', '.PDF', 'users_guide_en.pdf'])"
                      target="_blank"
                      >User&#39;s Guide(PDF)</a
                    ><span class="icon-angle-right pull-right"></span>
                  </li>
                  <li class="list-group-item">
                    <a href="javascript:void(0);">Tokyo Asia</a
                    ><span class="icon-angle-right pull-right"></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <nav class="navbar navbar-default top-nk225">
      <div class="container">
        <div class="container-fluid">
          <div class="row">
            <div class="hidden-xs" id="top_realdate">
              <div class="col-xs-12 col-sm-3 top-nk225-l-panel">
                <div class="top-nk225-text-nk">
                  Tokyo Indexes
                </div>
                <div class="top-nk225-text">
                  <!--daily_changing--><span
                    ><div id="datedtime_nkave">{{date_show}} {{status}}</div></span
                  >
                </div>
                <div class="top-nk225-text-link">
                  <span
                    class="icon-graph-line-points zoom-icon"
                    aria-hidden="true"
                  ></span
                  >&nbsp;<a
                    class="right"
                    href="#idx_carousel"
                    data-target="#idx_carousel"
                    data-slide-to="1"
                    >Intraday Chart</a
                  >
                </div>
              </div>
            </div>

            <div
              class="carousel slide col-xs-12 col-sm-7"
              id="idx_carousel"
              data-ride="carousel"
            >
              <ol
                class="carousel-indicators carousel-indicators-xs indicators-bottom"
              >
                <li
                  data-target="#idx_carousel"
                  data-slide-to="0"
                  class="active"
                ></li>
                <li data-target="#idx_carousel" data-slide-to="1" class=""></li>
              </ol>
              <div class="carousel-inner" role="listbox">
                <div class="item active" id="idx_side">
                  <div id="top_nk225">
                    <div class="hidden-xs">
                      <!--daily_changing-->
                      <div class="top-nk225-value" id="current_price_1">
                        <template v-if="this.last && this.last.last_threeall">{{numberFormat(this.last.last_threeall,true)}}</template>
                      </div>
                      <!--daily_changing-->
                      <div
                        class="top-nk225-differ re-top-nk225-differ"
                        id="diff"
                      >
                      <template v-if="this.last && this.last.last_twoall">{{numberFormat(this.last.last_twoall,true)}} ({{numberFormat(this.last.change,true)}}%)&nbsp;&nbsp;</template>
                        <span
                          :class="{'icon-arrow-dark-circle-right-down':(Number(this.last.change)<0)?true:false,'icon-arrow-dark-circle-right-up':(Number(this.last.change)>0)?true:false,'zoom-icon':true}"
                          aria-hidden="true"
                        ></span>
                      </div>
                    </div>
                    <div class="visible-xs">
                      <div class="row visible-xs">
                        <div class="col-xs-12 col-sm-3 top-nk225-l-panel-xs">
                          <div class="top-nk225-text">
                            Tokyo Indexes
                          </div>
                          <div class="top-nk225-text">
                            <!--daily_changing--><span
                              ><div id="datedtime_nkave_xs">
                                {{date_show}}&nbsp;*Close
                              </div></span
                            >
                          </div>
                          <div class="top-nk225-text-link">
                            <span
                              class="icon-graph-line-points zoom-icon"
                              aria-hidden="true"
                            ></span
                            >&nbsp;
                            <a
                              class="right"
                              href="#idx_carousel"
                              data-target="#idx_carousel"
                              data-slide-to="1"
                            >
                              Intraday Chart
                            </a>
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                          <!--daily_changing-->
                          <div class="top-nk225-value-xs" id="current_price">
                            <template v-if="this.last && this.last.last_threeall">{{numberFormat(this.last.last_threeall,true)}}</template>
                          </div>
                          <!--daily_changing-->
                          <div class="top-nk225-differ" id="diff_xs">
                            <template v-if="this.last && this.last.last_twoall">{{numberFormat(this.last.last_twoall,true)}} ({{numberFormat(this.last.change,true)}}%)&nbsp;</template>
                            <span
                              :class="{'icon-arrow-dark-circle-right-down':(Number(this.last.change)<0)?true:false,'icon-arrow-dark-circle-right-up':(Number(this.last.change)>0)?true:false,'zoom-icon':true}"
                              aria-hidden="true"
                            ></span>
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-3">
                          <div class="row">
                            <div class="top-nk225-menu">
                              <a
                                href="javascript:void(0);"
                              >
                                <span
                                  class="icon-arrow-circle-right zoom-icon"
                                  aria-hidden="true"
                                ></span
                                >&nbsp; Daily Summary
                              </a>
                            </div>
                            <div class="top-nk225-menu">
                              <a
                                href="javascript:void(0);"
                              >
                                <span
                                  class="icon-arrow-circle-right zoom-icon"
                                  aria-hidden="true"
                                ></span
                                >&nbsp; More Details
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item">
                  <div
                    style="width:100%;"
                    class="carousel-second"
                    id="top_intradaychart"
                  >
                    <div class="height-mard10px">
                      <div class="row" id="current_sub">
                        <!--daily_changing-->
                        <div id="price_diff">
                          <div class="current_sub_pos">
                            <span class="current_sub_price"><template v-if="this.last && this.last.last_threeall">{{numberFormat(this.last.last_threeall,true)}} </template></span>
                            <template v-if="this.last && this.last.last_twoall">{{numberFormat(this.last.last_twoall,true)}} ({{numberFormat(this.last.change,true)}}%)&nbsp;</template>
                            <span
                              :class="{'icon-arrow-dark-circle-right-down':(Number(this.last.change)<0)?true:false,'icon-arrow-dark-circle-right-up':(Number(this.last.change)>0)?true:false,'zoom-icon':true}"
                              aria-hidden="true"
                            ></span>
                          </div>
                        </div>
                      </div>
                      <div class="row chart_box">
                        <div
                          class="center-block intraday-chart chart_size"
                          id="intradaychart"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="hidden-xs">
              <div class="col-xs-12 col-sm-2 top-nk225-r-panel">
                <div class="row">
                  <div class="top-nk225-menu">
                    <a
                      href="javascript:void(0);"
                      ><span
                        class="icon-arrow-circle-right zoom-icon"
                        aria-hidden="true"
                      ></span
                      >&nbsp;More Details</a
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="top-nk225-menu">
                    <a
                      href="javascript:void(0);"
                      ><span
                        class="icon-arrow-circle-right zoom-icon"
                        aria-hidden="true"
                      ></span
                      >&nbsp;Daily Summary</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <!-- ナビゲーションメニュー(トップ画面) -->
    <nav class="hidden-xs navbar-default">
      <div class="container">
        <div class="collapse navbar-collapse submenu" id="navbar-menu">
          <ul class="nav navbar-nav tab-menu-font">
            <li class=" headder-button">
              <a href="javascript:void(0);"
                >Index List</a
              >
              <div>
                <ul>
                  <li>
                    <a
                      href="javascript:void(0);"
                      >Index List</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      >Download Center</a
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <a href="javascript:void(0);"
                >Archives</a
              >
              <div>
                <ul>
                  <li>
                    <a
                      href="javascript:void(0);"
                      >Daily Summary</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      >Historical Data in Tokyo 700</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      >Records in Tokyo 700</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      >Winning rate of the day</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      >Chronology</a
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <a href="javascript:void(0);"
                >News&amp;Release</a
              >
            </li>
            <li>
              <a href="javascript:void(0);"
                >License</a
              >
            </li>
            <li>
              <a href="javascript:void(0);"
                >Governance</a
              >
            </li>
            <li class="asiap-color">
              <a href="javascript:void(0);" target="_blank">Asia Indexes</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="container space-20">
      <div class="border border-main" >
      <img class="responsive-image bannernew" src="@/assets/images/Tokyo-Banner_1.png">
      </div>
    </div>
    <div class="container space-30">
      <h3 style="font-weight: bold;color: #fff;padding-top: 5px;padding-bottom: 10px;">Tokyo Indexes Historical Data</h3>
    </div>
    <div class="container space-20">
      <div class="border border-main">
        <div class="overflow-x-auto desktop:overflow-visible">
          <table
          class="tbl"
            data-test="historical-data-table"
            style="--freeze-column-width:100px;"
          >
            <thead class="datatable_head__ysELt">
              <tr class="datatable_row__qHMpQ">
                <th class="datatable_cell__0y0eu">
                  <div class="datatable_cell__wrapper__ddKL4">
                    <span style="color:white;">Date</span>
                  </div>
                </th>
                <th
                  class="datatable_cell__0y0eu datatable_cell--align-end__fwomz"
                >
                  <div class="datatable_cell__wrapper__ddKL4">
                    <span style="color:white">Price(Mor)</span>
                  </div>
                </th>
                <th
                  class="datatable_cell__0y0eu datatable_cell--align-end__fwomz"
                >
                  <div class="datatable_cell__wrapper__ddKL4">
                    <span style="color:white">Price(Aft)</span>
                  </div>
                </th>
                <th
                  class="datatable_cell__0y0eu datatable_cell--align-end__fwomz hide-on-mobile"
                >
                  <div class="datatable_cell__wrapper__ddKL4">
                    <span style="color:white">Open</span>
                  </div>
                </th>
                <th
                  class="datatable_cell__0y0eu datatable_cell--align-end__fwomz"
                >
                  <div class="datatable_cell__wrapper__ddKL4">
                    <span style="color:white">High</span>
                  </div>
                </th>
                <th
                  class="datatable_cell__0y0eu datatable_cell--align-end__fwomz"
                >
                  <div class="datatable_cell__wrapper__ddKL4">
                    <span style="color:white">Low</span>
                  </div>
                </th>
                <th
                  class="datatable_cell__0y0eu datatable_cell--align-end__fwomz hide-on-mobile"
                >
                  <div class="datatable_cell__wrapper__ddKL4">
                    <span style="color:white">Vol</span>
                  </div>
                </th>
                <th
                  class="datatable_cell__0y0eu datatable_cell--align-end__fwomz hide-on-mobile"
                >
                  <div class="datatable_cell__wrapper__ddKL4">
                      <span style="color:white">Change %</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="datatable_body__cs8vJ">
              <tr
                class="datatable_row__qHMpQ"
                data-test="historical-data-table-row" v-for="(item,index) in data"
              >
                <td class="datatable_cell__0y0eu font-bold" style="text-align: center;color:#000; background-color: #fff;">
                  {{ showDate(item.datetime) }}
                </td>
                <td
                  class="datatable_cell__0y0eu datatable_cell--align-end__fwomz datatable_cell--up__Gt_ed"
                  dir="ltr" :style="{'text-align': 'right','color':checkColor(item.twoall),'background-color': '#fff;'}"
                >
                <template v-if="item.threeall">
                  {{ numberFormat(item.threeall,true) }} ({{ (numberFormat(item.twoall,true)) }})
                </template>
                </td>
                <td
                  class="datatable_cell__0y0eu datatable_cell--align-end__fwomz datatable_cell--up__Gt_ed"
                  dir="ltr" :style="{'text-align': 'right','color':checkColor(item.change),'background-color': '#fff;'}"
                >
                <template v-if="item.threeall2">
                  {{ numberFormat(item.threeall2,true) }} ({{ (numberFormat(item.twoall2,true)) }})
                </template>
                </td>
                <td
                  class="datatable_cell__0y0eu datatable_cell--align-end__fwomz hide-on-mobile" style="text-align: right;color:#000;background-color: #fff;"
                >
                  {{ numberFormat(item.open,true) }}
                </td>
                <td
                  class="datatable_cell__0y0eu datatable_cell--align-end__fwomz" style="text-align: right;color:#000;background-color: #fff;"
                >
                  {{ numberFormat(item.max,true) }}
                </td>
                <td
                  class="datatable_cell__0y0eu datatable_cell--align-end__fwomz" style="text-align: right;color:#000;background-color: #fff;"
                >
                 {{ numberFormat(item.min,true) }}
                </td>
                <td
                  class="datatable_cell__0y0eu datatable_cell--align-end__fwomz hide-on-mobile"
                  data-test="volume-cell" style="text-align: right;color:#000;background-color: #fff;"
                >
                 {{ numberFormat(item.volumn,true) }}M
                </td>
                <td
                  class="datatable_cell__0y0eu datatable_cell--align-end__fwomz datatable_cell--up__Gt_ed font-bold hide-on-mobile"
                  dir="ltr" :style="{'text-align': 'right','color':checkColor(item.change),'background-color': '#fff;'}"
                >
                  {{ (item.change.toString().charAt(0) === '-')?item.change:'+'+item.change }}%
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="image-container" style="display: grid;
    grid-auto-flow: column;
    gap: 10px; /* ช่องไฟระหว่างรูปภาพ */
    align-items: center;padding-top: 20px;">
        <div><img class="responsive-image" src="@/assets/images/Nikkei_3.jpg"></div>
        <div><img class="responsive-image" src="@/assets/images/Nikkei_4.jpg"></div>
        </div>
        <div class="image-container" style="display: grid;
    grid-auto-flow: column;
    gap: 10px; /* ช่องไฟระหว่างรูปภาพ */
    align-items: center;padding-top: 20px;">
        <div><img class="responsive-image2" src="@/assets/images/Tokyo-Banner_6.png"></div>
        </div>
      </div>
    </div>

    <div class="container-fluid footer-nav">
      <div class="container">
        <div class="row" style="text-align: center;">
          <ul>
            <li>
              <a
                href="javascript:void(0);"
                onclick="_gaq.push(['_trackEvent', 'TOP_EN', '.PDF', 'terms_of_use_en.pdf'])"
                target="_blank"
                class="more-color"
                >Term of Use(PDF)</a
              >&nbsp;|&nbsp;
            </li>
            <li>
              <a
                href="javascript:void(0);"
                class="more-color"
                >Sitemap</a
              >&nbsp;|&nbsp;
            </li>
            <li>
              <a
                href="javascript:void(0);"
                class="more-color"
                >Contact</a
              >&nbsp;|&nbsp;
            </li>
            <li>
              <a
                href="javascript:void(0);"
                onclick="_gaq.push(['_trackEvent', 'TOP_EN', '.PDF', 'users_guide_en.pdf'])"
                target="_blank"
                class="more-color"
                >User&#39;s Guide(PDF)</a
              >&nbsp;|&nbsp;
            </li>
            <li>
              <a href="javascript:void(0);" class="more-color"
                >Tokyo</a
              >&nbsp;|&nbsp;
            </li>
            <li>
              <a
                href="javascript:void(0);"
                class="more-color"
                >Guide for "Premium Data Package"</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="container-fluid nikkei-signature">
      <div class="container">
        <div class="row">
          <ul>
            <li>
              <!--[if lte IE 8
                ]><img
                  src="/nkave/assets/logo_nikkei_footer.png"
                  title="NIKKEI"
                  alt="NIKKEI"
              /><![endif]-->
              <!--[if gte IE 9
              ]><!--><!--<![endif]-->
            </li>
            <li style="padding-top: 5px;">Tokyo Indexes. No reproduction without permission.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import 'firebase/database'
import 'firebase/firestore'
import moment from "moment-timezone";
export default {
  name: "Home",
  mounted() {
    // this.getBackGround()
    // this.getLotto()
    // this.getBanners()
    $("#idx_carousel").carousel({
      interval: 10000,
    });
    this.date_show = moment().tz("Asia/Bangkok").format("MMM/DD/YYYY");
    this.getLotto();
    this.getLast();
  },
  computed: {},
  data() {
    return {
      last:[],
      status: '*Close',
      date_show:'',
      data_price: 0,
      data_prev: 0,
      chart_data: [],
      ChartPlot: "",
      data_label: [],
      data_time: [],
      first: "",
      data: [],
    };
  },
  methods: {
    checkColor(num){
      if(num){
        if(Number(num)<0){
          return 'red';
        }else{
          return '#0ea600';
        }
      }
    },
    numberFormat(x,decimal){
      if(x){
        if(decimal){
          return Number(x).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }else{
          return Number(x).toLocaleString(undefined);
        }
      }
      
    },
    showDate(datetime){
      return datetime.split(' ')[0];
    },
    renderChart() {
      this.chart_data = [this.data_price, this.data_prev];
      //チャートオプション
      const options_done = {
        axesDefaults: {},
        grid: {
          background: "#000",
          shadow: false,
          borderColor: "#fff",
          gridLineColor: "#ff0000",
        },
        axes: {
          xaxis: {
            renderer: $.jqplot.DateAxisRenderer,
            ticks: this.data_time,
            tickOptions: {
              formatString: "%R",
              textColor: "#000",
              textSize: 2,
              showGridline: false,
            },
          },
          y2axis: {
            ticks: this.data_label,
            tickOptions: {
              formatString: "%'d",
              textColor: "#000",
              showGridline: true,
            },
          },
        },
        grid: {
          background: "#3a0000",
          drawBorder: false,
          shadow: false,
        },
        seriesDefaults: {
          markerOptions: { show: false },
          shadow: false,
          lineWidth: 1,
          yaxis: "y2axis",
        },
        series: [
          {
            color: "#f8f8ff",
            lineWidth: 2,
            showMarker: false,
            fill: true,
            fillAndStroke: true,
            fillAlpha: 0.4,
            fillColor: "#f8f8ff",
          },
          {
            color: "#ff0000",
            lineWidth: 1.5,
          },
        ],
      };
      //チャート生成
      this.ChartPlot = $.jqplot("intradaychart", this.chart_data, options_done);
      this.ChartPlot.replot();
    },
    async getLotto() {
      let data = (await firebase.database().ref("/huay/14").orderByChild("datetime").limitToLast(20).once("value")).val();
      data = _.orderBy(data, ["datetime"], ["desc"]);
      if (data) {
        for (const x in data) {
          const d = data[x].datetime.split(" ");
          const date = d[0].split("-");
          const time = d[1].split(":");
          const datetime = Number(date[0] + "" + date[1] + "" + date[2] + "" + time[0] + "" + time[1]);
          if (moment(data[x].datetime).add(-2,'hours').add(-15,'minutes').tz("Asia/Bangkok").format("YYYYMMDDHHmm") > Number(moment().tz("Asia/Bangkok").format("YYYYMMDDHHmm"))) {
            continue;
          }
          this.data.push(data[x]);
        }
      }
      if(moment().tz('Asia/Bangkok').format('HHmm') > 800 && moment().tz('Asia/Bangkok').format('HHmm') < 1450){
        const created = firebase.database().ref('/huay/14').orderByChild('datetime').startAt(moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 10:50');
        created.on("child_changed", snapshot => {
          if(snapshot.val()){
            this.data.shift();
            this.data.unshift(snapshot.val());
          }
        });
      }
      setInterval(this.getLastData, 1000);
    },
    formatDate(date) {
      const dd = moment(date)
        .tz("Asia/Bangkok")
        .format("DD");
      const year = moment(date)
        .tz("Asia/Bangkok")
        .format("YYYY");
      const month = this.convertToLaosMonth(
        moment(date)
          .tz("Asia/Bangkok")
          .format("MMMM")
      );
      return dd + " " + month + " " + year;
    },
    formatTime(date) {
      return moment(date)
        .tz("Asia/Bangkok")
        .format("HH:mm");
    },
    dateToday() {
      return moment()
        .tz("Asia/Bangkok")
        .format("dddd, DD MMMM YYYY");
    },
    async getLastData() {
      const now = moment().tz("Asia/Bangkok").format('HHmm');
      if(Number(now) < 800 || Number(now) > 1450 || (Number(now) > 1050 && Number(now) < 1150)){
        this.status = '*Close';
      }else{
        this.status = '*Open';
      }
    },
    async getLast() {
      //label = 6
      const json = `{"price":[["09:00:00",27303.28],["09:01:00",27270.98],["09:02:00",27239.66],["09:03:00",27283.21],["09:04:00",27276.58],["09:05:00",27270.17],["09:06:00",27291.55],["09:07:00",27280.57],["09:08:00",27300.49],["09:09:00",27245.37],["09:10:00",27253.88],["09:11:00",27270.11],["09:12:00",27299.63],["09:13:00",27290.12],["09:14:00",27288.40],["09:15:00",27276.31],["09:16:00",27269.81],["09:17:00",27260.65],["09:18:00",27263.49],["09:19:00",27235.92],["09:20:00",27264.76],["09:21:00",27251.83],["09:22:00",27262.44],["09:23:00",27264.08],["09:24:00",27280.50],["09:25:00",27275.25],["09:26:00",27286.65],["09:27:00",27315.14],["09:28:00",27349.19],["09:29:00",27351.69],["09:30:00",27329.85],["09:31:00",27309.48],["09:32:00",27306.56],["09:33:00",27311.79],["09:34:00",27291.27],["09:35:00",27298.26],["09:36:00",27297.93],["09:37:00",27300.02],["09:38:00",27308.82],["09:39:00",27297.94],["09:40:00",27289.33],["09:41:00",27282.70],["09:42:00",27295.83],["09:43:00",27304.85],["09:44:00",27304.07],["09:45:00",27306.85],["09:46:00",27301.56],["09:47:00",27275.76],["09:48:00",27265.83],["09:49:00",27266.29],["09:50:00",27278.83],["09:51:00",27265.27],["09:52:00",27271.28],["09:53:00",27271.99],["09:54:00",27294.43],["09:55:00",27292.02],["09:56:00",27291.26],["09:57:00",27283.02],["09:58:00",27284.39],["09:59:00",27300.20],["10:00:00",27292.78],["10:01:00",27244.20],["10:02:00",27242.72],["10:03:00",27241.94],["10:04:00",27219.41],["10:05:00",27229.20],["10:06:00",27228.00],["10:07:00",27239.43],["10:08:00",27236.34],["10:09:00",27231.38],["10:10:00",27234.75],["10:11:00",27248.19],["10:12:00",27244.04],["10:13:00",27241.37],["10:14:00",27245.90],["10:15:00",27236.81],["10:16:00",27234.12],["10:17:00",27242.09],["10:18:00",27225.30],["10:19:00",27210.46],["10:20:00",27229.96],["10:21:00",27230.53],["10:22:00",27226.11],["10:23:00",27239.95],["10:24:00",27243.96],["10:25:00",27231.91],["10:26:00",27226.61],["10:27:00",27227.25],["10:28:00",27228.48],["10:29:00",27216.09],["10:30:00",27216.16],["10:31:00",27209.58],["10:32:00",27208.80],["10:33:00",27214.38],["10:34:00",27203.05],["10:35:00",27220.04],["10:36:00",27219.48],["10:37:00",27179.99],["10:38:00",27188.70],["10:39:00",27181.01],["10:40:00",27147.98],["10:41:00",27132.28],["10:42:00",27125.67],["10:43:00",27120.80],["10:44:00",27124.97],["10:45:00",27160.36],["10:46:00",27154.00],["10:47:00",27151.45],["10:48:00",27156.17],["10:49:00",27143.62],["10:50:00",27153.99],["10:51:00",27143.16],["10:52:00",27106.72],["10:53:00",27110.75],["10:54:00",27114.24],["10:55:00",27117.96],["10:56:00",27123.82],["10:57:00",27127.79],["10:58:00",27142.78],["10:59:00",27149.57],["11:00:00",27150.22],["11:01:00",27153.57],["11:02:00",27154.52],["11:03:00",27153.71],["11:04:00",27155.46],["11:05:00",27158.96],["11:06:00",27148.89],["11:07:00",27156.98],["11:08:00",27153.92],["11:09:00",27162.48],["11:10:00",27153.54],["11:11:00",27163.23],["11:12:00",27161.29],["11:13:00",27160.64],["11:14:00",27152.06],["11:15:00",27148.08],["11:16:00",27149.05],["11:17:00",27140.35],["11:18:00",27146.34],["11:19:00",27145.52],["11:20:00",27140.46],["11:21:00",27124.09],["11:22:00",27121.68],["11:23:00",27115.74],["11:24:00",27121.87],["11:25:00",27117.98],["11:26:00",27115.13],["11:27:00",27107.58],["11:28:00",27106.56],["11:29:00",27105.53],["11:30:00",27106.34],["12:30:00",27106.34],["12:31:00",27013.81],["12:32:00",27020.27],["12:33:00",27036.24],["12:34:00",27029.73],["12:35:00",27030.83],["12:36:00",27028.53],["12:37:00",27038.56],["12:38:00",27038.69],["12:39:00",27040.48],["12:40:00",27046.60],["12:41:00",27041.91],["12:42:00",27055.79],["12:43:00",27062.46],["12:44:00",27070.78],["12:45:00",27063.15],["12:46:00",27069.30],["12:47:00",27066.32],["12:48:00",27065.10],["12:49:00",27067.85],["12:50:00",27067.33],["12:51:00",27063.89],["12:52:00",27062.33],["12:53:00",27068.75],["12:54:00",27071.71],["12:55:00",27068.14],["12:56:00",27054.45],["12:57:00",27035.92],["12:58:00",27053.28],["12:59:00",27057.79],["13:00:00",27054.31],["13:01:00",27051.65],["13:02:00",27046.81],["13:03:00",27048.40],["13:04:00",27049.02],["13:05:00",27040.54],["13:06:00",27040.71],["13:07:00",27034.66],["13:08:00",27030.08],["13:09:00",27028.17],["13:10:00",27026.01],["13:11:00",27030.34],["13:12:00",27025.18],["13:13:00",27033.66],["13:14:00",27033.01],["13:15:00",27045.61],["13:16:00",27050.78],["13:17:00",27060.68],["13:18:00",27059.75],["13:19:00",27063.06],["13:20:00",27059.01],["13:21:00",27059.84],["13:22:00",27061.69],["13:23:00",27063.85],["13:24:00",27062.61],["13:25:00",27061.05],["13:26:00",27056.62],["13:27:00",27057.88],["13:28:00",27057.02],["13:29:00",27049.65],["13:30:00",27043.07],["13:31:00",27049.96],["13:32:00",27026.14],["13:33:00",27014.56],["13:34:00",27022.82],["13:35:00",27020.37],["13:36:00",27015.28],["13:37:00",27016.92],["13:38:00",27009.47],["13:39:00",26987.16],["13:40:00",26971.49],["13:41:00",26986.31],["13:42:00",26984.67],["13:43:00",26988.74],["13:44:00",26989.77],["13:45:00",26995.02],["13:46:00",26993.28],["13:47:00",26999.16],["13:48:00",26998.47],["13:49:00",26994.64],["13:50:00",26996.42],["13:51:00",26998.28],["13:52:00",26984.72],["13:53:00",26984.54],["13:54:00",26991.85],["13:55:00",26987.27],["13:56:00",26984.60],["13:57:00",26988.88],["13:58:00",26991.37],["13:59:00",27001.81],["14:00:00",26993.86],["14:01:00",26982.28],["14:02:00",26967.27],["14:03:00",26954.22],["14:04:00",26955.85],["14:05:00",26962.35],["14:06:00",26974.68],["14:07:00",26991.85],["14:08:00",27004.00],["14:09:00",27012.78],["14:10:00",27018.83],["14:11:00",27015.90],["14:12:00",27015.05],["14:13:00",27018.36],["14:14:00",27016.96],["14:15:00",27006.88],["14:16:00",27000.84],["14:17:00",26994.36],["14:18:00",26996.45],["14:19:00",26992.03],["14:20:00",27001.52],["14:21:00",27004.47],["14:22:00",27003.01],["14:23:00",26995.57],["14:24:00",26993.35],["14:25:00",27010.57],["14:26:00",27010.16],["14:27:00",27011.27],["14:28:00",27003.29],["14:29:00",27006.92],["14:30:00",27013.61],["14:31:00",27006.00],["14:32:00",27017.72],["14:33:00",27025.34],["14:34:00",27026.33],["14:35:00",27042.18],["14:36:00",27037.86],["14:37:00",27041.65],["14:38:00",27030.90],["14:39:00",27021.09],["14:40:00",27024.06],["14:41:00",27027.88],["14:42:00",27027.14],["14:43:00",27015.53],["14:44:00",27005.13],["14:45:00",27009.07],["14:46:00",27011.67],["14:47:00",27015.33],["14:48:00",27019.09],["14:49:00",27014.53],["14:50:00",26999.56],["14:51:00",27000.75],["14:52:00",26993.01],["14:53:00",26981.82],["14:54:00",26977.69],["14:55:00",26987.74],["14:56:00",26981.93],["14:57:00",26975.60],["14:58:00",26978.57],["14:59:00",26975.36],["15:00:00",26945.67],["15:01:00",26945.67],["15:02:00",26945.67],["15:03:00",26945.67],["15:04:00",26945.67],["15:05:00",26945.67],["15:06:00",26945.67],["15:07:00",26945.67],["15:08:00",26945.67],["15:09:00",26945.67],["15:10:00",26945.67]],"prev":[["09:00",27333.79],["16:00",27333.79]],"label":[26750,26900,27050,27200,27350,27500],"time":[["09:00","09:00"],["10:00","10:00"],["11:00","11:00"],["12:00","12:00"],["13:00","13:00"],["14:00","14:00"],["15:00","15:00"],["16:00","16:00"]]}`;
      const dataJson = JSON.parse(json);
      const price = [];
      let date;
      if(Number(moment().tz('Asia/Bangkok').format('HHmm'))<=800){
        date = moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD');
      }else{
        date = moment().tz('Asia/Bangkok').format('YYYY-MM-DD');
      }
      firebase.firestore().collection("tokyo").where("date", "==", date).orderBy('updatedate','asc').onSnapshot(async (snapshot) => {
        const data = [];
        snapshot.docChanges().forEach((change) => {
          data[change.doc.id] = change.doc.data();
          data[change.doc.id].typedata = change.type;
        });
        let min = 0;
        let max = 0;
        for(const x in data){
          if (data[x].typedata === "added") {
            this.last = data[x];
            const createdate1 = data[x].createdate.split(' ')[1]
            const time = createdate1.split(':');
            //
            const time0 = (Number(time[0])+2).toString().padStart(2, "0");
            if(data[x].last_threeall){
              price.push([time0+':'+time[1]+':00',Number(data[x].last_threeall)]);
            }else if(data[x].threeall){
              price.push([time0+':'+time[1]+':00',Number(data[x].threeall)]);
            }
            min = data[x].min;
            max = data[x].max;
          }
        }
        // console.log(max);
        // console.log(min);
        // let rangMax = max.toString().substring(0,2);
        // let rangMin = min.toString().substring(0,2);
        // rangMax = Number(rangMax)+1+'000';
        // rangMin = Number(rangMin)-1+'000';
        let rangMax = max.toString().substring(0,3);
        let rangMin = min.toString().substring(0,3);
        rangMax = Number(rangMax)+1+'00';
        rangMin = Number(rangMin)+'00';
        //console.log(rangMax,rangMin);
        let range = Math.floor((Number(rangMax) - Number(rangMin))/50);
        if(range<6) range = 6;
        const step = 50;
        const xAxisValues = [];
        for (let i = 0; i < range; i++) {
          xAxisValues.push(Number(rangMin) + i * step);
        }
        //console.log(xAxisValues);
        const average = (Number(max)+Number(min))/2;
        for(const x in dataJson.prev){
          dataJson.prev[x][1] = average;
        }
        this.data_price = price;
        this.data_prev = dataJson.prev;
        this.data_label = xAxisValues;
        this.data_time = dataJson.time;
        $("#idx_carousel").on("slid.bs.carousel", () => {
          this.renderChart();
        });
      });
    }
  },
};
</script>
<style scoped>
.datatable_cell__wrapper__ddKL4 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.tbl {
  border-collapse: collapse;
  width:100%;
}
.tbl th,
.tbl td {
  padding: 5px;
  border: solid 1px #777;
  background-color: #fff;
}
.tbl th {
  background-color: #5b0000;
}
@media (max-width: 768px) {
  .hide-on-mobile {
    display: none;
  }
}
@media (min-width: 768px) {
  .bannernew {
  min-width: 970px;
}
}

.image-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.responsive-image {
  width: 100%;
  max-width: 485px;
  height: auto;
}
.responsive-image2 {
  width: 100%;
  height: auto;
}
</style>
